<template>
  <div class="content">
    <div class="iconWrapper">
      <i class="icon bi bi-check" />
    </div>
    <div class="title">{{ $t("game.preGameModalWaitingReady.title") }}</div>
    <div class="subtitle">{{ $t("game.preGameModalWaitingReady.subtitle") }}</div>
    <div class="textBox">
      <div class="iconWrapper2">
        <i class="icon bi bi-exclamation" />
      </div>
      <div class="text">{{ $t("game.preGameModalWaitingReady.warning") }}</div>
    </div>
    <Button class="primary" :label="$t('game.preGameModalWaitingReady.button')" @click="$emit('go')" />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  .iconWrapper {
    width: 64px;
    height: 64px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: 36px;

    background-color: #1fa969;
  }

  .title {
    font-size: 32px;
    font-weight: 700;

    margin: 8px 0;

    @media screen and (max-width: $small-screen) {
      font-size: 24px;
      text-align: center;
    }
  }

  .subtitle {
    font-size: 18px;

    @media screen and (max-width: $small-screen) {
      font-size: 16px;
    }

    text-align: center;
  }

  .textBox {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;

    margin: 40px 0;

    border-radius: 6px;
    border: 1px solid #f2cb36;
    background: #2d2a27;

    .iconWrapper2 {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      border: 2px solid #f2cb36;

      font-size: 24px;
    }

    .text {
      font-size: 16px;

      @media screen and (max-width: $small-screen) {
        font-size: 12px;
      }
    }
  }
}
</style>

<script setup lang="ts"></script>
